import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { OliveTreeLogo } from './DecorativeElements';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const navLinks = [{
    name: 'Home',
    id: 'home'
  }, {
    name: 'Apartments',
    id: 'apartments'
  }, {
    name: 'Moments',
    id: 'moments'
  }, {
    name: 'Booking',
    id: 'booking'
  }, {
    name: 'Contact Us',
    id: 'contact'
  }];
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[var(--paper)] shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-321">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex justify-between items-center" data-id="element-322">
        {/* Logo */}
        <button onClick={() => scrollToSection('home')} className="flex items-center gap-2 group" data-id="element-323">
          <OliveTreeLogo className={`transition-all duration-300 ${isScrolled ? 'w-10 h-10' : 'w-12 h-12'}`} data-id="element-324" />
          <span className={`font-script text-2xl text-[var(--sienna)] ${isScrolled ? 'opacity-100' : 'opacity-0 md:opacity-100'}`} data-id="element-325">
            WaCa - Monopoli
          </span>
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-326">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="font-serif text-lg text-[var(--brown)] hover:text-[var(--sienna)] transition-colors relative group" data-id="element-327">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[var(--sage)] transition-all duration-300 group-hover:w-full" data-id="element-328" />
            </button>)}
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-[var(--brown)]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-329">
          {isMobileMenuOpen ? <X size={24} data-id="element-330" /> : <Menu size={24} data-id="element-331" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full bg-[var(--paper)] border-b border-[var(--sage)] shadow-lg py-4 px-4 md:hidden flex flex-col gap-4 animate-fade-in" data-id="element-332">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="font-serif text-xl text-[var(--brown)] py-2 border-b border-[var(--sage)] border-opacity-20 last:border-0 text-left" data-id="element-333">
              {link.name}
            </button>)}
        </div>}
    </nav>;
}